export const Routes = {
  // pages
  Presentation: { path: '/presentation' },
  DashboardOverview: { path: '/dashboard/overview' },
  // ListAds: { path: '/ads' },
  ListAnnouncements: { path: '/announcements' },
  AnnouncementAdd: { path: '/add-announcement' },
  // NewAd: { path: '/new-ad' },
  // NewAd2: { path: '/new-ad2' },
  Settings: { path: '/settings' },
  Upgrade: { path: '/upgrade' },
  BootstrapTables: { path: '/tables/bootstrap-tables' },
  Billing: { path: '/billing' },
  Invoice: { path: '/examples/invoice' },
  Signin: { path: '/' },
  Signup: { path: '/sign-up' },
  ForgotPassword: { path: '/examples/forgot-password' },
  ResetPassword: { path: '/examples/reset-password' },
  Lock: { path: '/examples/lock' },
  NotFound: { path: '/examples/404' },
  ServerError: { path: '/examples/500' },
  Success: { path: '/success' },

  // docs
  DocsOverview: { path: '/documentation/overview' },
  DocsDownload: { path: '/documentation/download' },
  DocsQuickStart: { path: '/documentation/quick-start' },
  DocsLicense: { path: '/documentation/license' },
  DocsFolderStructure: { path: '/documentation/folder-structure' },
  DocsBuild: { path: '/documentation/build-tools' },
  DocsChangelog: { path: '/documentation/changelog' },

  // components
  Accordions: { path: '/components/accordions' },
  Alerts: { path: '/components/alerts' },
  Badges: { path: '/components/badges' },
  Widgets: { path: '/widgets' },
  Breadcrumbs: { path: '/components/breadcrumbs' },
  Buttons: { path: '/components/buttons' },
  Forms: { path: '/components/forms' },
  Modals: { path: '/components/modals' },
  Navs: { path: '/components/navs' },
  Navbars: { path: '/components/navbars' },
  Pagination: { path: '/components/pagination' },
  Popovers: { path: '/components/popovers' },
  Progress: { path: '/components/progress' },
  Tables: { path: '/components/tables' },
  Tabs: { path: '/components/tabs' },
  Tooltips: { path: '/components/tooltips' },
  Toasts: { path: '/components/toasts' },
  WidgetsComponent: { path: '/components/widgets' },
}
